import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sketches of day",
  "description": "",
  "published": "2006-07-08T00:00:00.000Z",
  "redirect_from": ["/blog/sketches-of-day/swizec/400"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Daily sketches huh. THe ones that are supposed to be refreshed every day under the webcam image... Yes they have kind of turned into now and anon sketches, terribly sorry about that. It's not that the eprson doing them is utterly lazy, it has more to do with there only being so many hours in the day and what's more, there being only so many hours in the day when said person can be productive.`}</p>
    <p>{`It used to be simple, go to school, rest for those five or six hours, come home and be productive. But oh no, it can't be thus at the time of summer vacation, oh no indeed. Right now it's more like get up at six in the morning bycicle to the driving lesson, driv earound in useless directions, bycicle to work; be productive for ten straight hours, bycicle home, eat nutrition. Spend time online catching up on internet events, sure there's some of this at work, but you know, not that much.`}</p>
    <p>{`Somehow that arrangement is leaving me too knackered to actually sketch, verily this was just because of the adjustment buffer and hopefully the organism has now adjusted to this rhythm of living and everything should be back to normal; at least as far as producing daily sketches go, which should thusly become daily.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      